import React from 'react';
import StepZilla from "react-stepzilla";
import AdministrationStep from '../Steps/AdministrationStep';
import CancelLocationStep from '../Steps/CancelLocationStep';
import ConfirmationStep from '../Steps/ConfirmationStep';
import ThankYouStep from '../Steps/ThankYouStep';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/UserData';

class CancellationElectricity extends React.Component {
    constructor(props) {
        super(props);

        this.stepsNavigation = true;

        this.submitCancellation = this.submitCancellation.bind(this);
        this.handleAdditionalGas = this.handleAdditionalGas.bind(this);
        this.additionalGas = false;
    }

    stepHandler (step) {
        if(this.steps.length === step + 1){
            console.log("Final Step!");
            this.cancellationFunction()
        }
    }

    handleAdditionalGas () {
        this.additionalGas = true;
    }

    submitCancellation (){
        this.stepsNavigation = false;
        this.props.submitCancellation();
    }

    render() {
        const steps = [
            {name: 'Verwaltung', component: <AdministrationStep 
                                                administration={this.props.Administration}
                                                updateAdminInfo={this.props.updateAdminInfo} />},
            {name: 'Strom-Verbrauchsstelle abmelden', component: <CancelLocationStep 
                                                                    administration={this.props.Administration}
                                                                    addCancellation={this.props.addCancellation}
                                                                    LocationCancellations={this.props.LocationCancellations}
                                                                    handleAdditionalGas={this.handleAdditionalGas}
                                                                    removeCancellation={this.props.removeCancellation}
                                                                    type={"electricity"}
                                                                    additionalGas={this.props.additionalGas} />},
            {name: 'Zusammenfassung', component: <ConfirmationStep additionalGas={this.additionalGas}/>},
            {name: 'Abschluss', component: <ThankYouStep  type={"electricity"} isRegistration={false} additionalGas={this.additionalGas} />}
        ]
        return (
            <div className='step-progress'>
                <StepZilla
                steps={steps}
                backButtonCls='btn btn-prev btn-primary float-left'
                nextButtonCls='btn btn-next btn-primary float-right'
                backButtonText='Zurück'
                nextButtonText='Weiter'
                prevBtnOnLastStep={false}
                nextTextOnFinalActionStep="Abmelden"
                onStepChange={this.stepHandler}
                stepsNavigation={false}
                cancellationFunction={this.submitCancellation}
                />
            </div>
        );
    }
}

export default connect(
  state => state.userData,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(CancellationElectricity);


// WEBPACK FOOTER //
// ./src/components/Forms/CancellationElectricity.js